/**
 * 资源中心导航树 Mock 数据
 */
import type { NavTreeNode } from '@/types/common';
import { ROUTE_PATHS } from '@/utils/constants';

/** 资源中心导航树 */
export const resourcesNavTree: NavTreeNode[] = [
  {
    id: 'marketing-materials',
    label: '营销素材',
    icon: 'campaign',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'product-brochures',
        label: '产品手册',
        icon: 'campaign',
        route: ROUTE_PATHS.RESOURCES_PRODUCT_BROCHURES,
      },
      {
        id: 'promotional-videos',
        label: '宣传视频',
        icon: 'campaign',
        route: ROUTE_PATHS.RESOURCES_PROMOTIONAL_VIDEOS,
      },
      {
        id: 'posters',
        label: '海报图片',
        icon: 'campaign',
        route: ROUTE_PATHS.RESOURCES_POSTERS,
      },
      {
        id: 'success-cases',
        label: '成功案例',
        icon: 'campaign',
        route: ROUTE_PATHS.RESOURCES_SUCCESS_CASES,
      },
    ],
  },
  {
    id: 'tech-docs',
    label: '技术文档',
    icon: 'description',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'whitepapers',
        label: '方案白皮书',
        icon: 'description',
        route: ROUTE_PATHS.RESOURCES_WHITEPAPERS,
      },
      {
        id: 'tech-specs',
        label: '技术规格',
        icon: 'description',
        route: ROUTE_PATHS.RESOURCES_TECH_SPECS,
      },
      {
        id: 'api-docs',
        label: '接口文档',
        icon: 'description',
        route: ROUTE_PATHS.RESOURCES_API_DOCS,
      },
    ],
  },
  {
    id: 'training-materials',
    label: '培训资料',
    icon: 'school',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'cert-training',
        label: '认证培训',
        icon: 'school',
        route: ROUTE_PATHS.RESOURCES_CERT_TRAINING,
      },
      {
        id: 'product-training',
        label: '产品培训',
        icon: 'school',
        route: ROUTE_PATHS.RESOURCES_PRODUCT_TRAINING,
      },
      {
        id: 'sales-training',
        label: '销售培训',
        icon: 'school',
        route: ROUTE_PATHS.RESOURCES_SALES_TRAINING,
      },
    ],
  },
  {
    id: 'contract-templates',
    label: '合同模板',
    icon: 'gavel',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'contract-template-list',
        label: '合同范本',
        icon: 'gavel',
        route: ROUTE_PATHS.RESOURCES_CONTRACT_TEMPLATES,
      },
      {
        id: 'agreement-templates',
        label: '协议模板',
        icon: 'gavel',
        route: ROUTE_PATHS.RESOURCES_AGREEMENT_TEMPLATES,
      },
      {
        id: 'legal-docs',
        label: '法律文件',
        icon: 'gavel',
        route: ROUTE_PATHS.RESOURCES_LEGAL_DOCS,
      },
    ],
  },
];
